import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class SettingsSingleSignOnRoute extends AuthenticatedRoute {}
